<template>
    <plane-vue-table :showSearchBox="false" title="" :fields="fields" :url="listUrl" :per-page="10" ref="table"
                     :page-number="false" :extra-params="{ start_date, vendor, end_date, searches, status }">
        <template #actions="{rowData}">
            <div class="btn-group-tight">
                <btn color="primary" class="btn-basic-b" size="xs" @click="viewDetails(rowData)" text="View"/>
            </div>
        </template>
    </plane-vue-table>
</template>

<script>
import urls from '../../../data/urls';

export default {
    name  : 'ListingComponent',
    props : {
        start_date : { type : String },
        end_date   : { type : String },
        vendor     : { type : String },
        status     : { type : String },
        searches   : { type : String }
    },
    data () {
        return {
            loading       : false,
            listUrl       : urls.purchaseAdmin.purchaseReturn.list,
            vendorOptions : urls.purchaseAdmin.vendorOptions,
            fields        : [
                {
                    name      : 'id',
                    sortField : 'id',
                    title     : 'Return ID'
                },
                {
                    name      : 'purchase',
                    sortField : 'purchase',
                    title     : 'Purchase ID'
                },
                {
                    name      : 'vendor.vendor_name',
                    sortField : 'vendor.vendor_name',
                    title     : 'Vendor'
                },
                {
                    name      : 'date',
                    sortField : 'date',
                    title     : 'Date'
                },
                {
                    name      : 'created_by',
                    sortField : 'created_by',
                    title     : 'Created By'
                },
                {
                    name      : 'status',
                    sortField : 'status',
                    title     : 'Status'
                },
                {
                    name  : '__slot:actions',
                    title : 'Actions'
                }

            ]
        };
    },
    methods : {
        viewDetails (rowData) {
            this.$router.push('/purchase/return/' + rowData.id + '/details/');
        }
    }
};
</script>
